import { createFileRoute } from '@tanstack/react-router'

import { TimeStep } from '@/pages/create-booking-page'

export const Route = createFileRoute('/_dashboard/branch/$branchId/create/_wizard/time')({
    component: TimeStep,
})
